import React, { useMemo } from 'react';
import { CircularFrame, Icon } from '@pinwheel/origami';
import CompanyIcon from '../../components/CompanyIcon';
import { useOpts } from '../../context';
import shouldShowEmployerMapping from '../../utils/should-show-employer-mapping';
import { getLinkApiTemplateType, getLinkApiTemplateWithActions, shouldLinkApiTemplateHideLogos, } from '../utils/link-api-response';
import { useAppSelector } from '../../state';
import { selectEmployerFromContext, selectIsUserEnteredPIIStep, selectLinkApiResponse, } from '../../state/slices/slice-link-api';
import { selectCurrentPath } from '../../state/history';
function isOnTerminalScreen(currentPath) {
    if (!currentPath)
        return false;
    var pathname = currentPath.pathname;
    return pathname === '/error' || pathname === '/success';
}
var LogoHeader = function () {
    var _a = useOpts(), companyColor = _a.companyColor, loadedPlatform = _a.loadedPlatform, featureFlags = _a.featureFlags;
    var loadedEmployer = useAppSelector(selectEmployerFromContext);
    var linkApiResponse = useAppSelector(selectLinkApiResponse);
    var currentPath = useAppSelector(selectCurrentPath);
    // TODO: CORE-1515 remove user-entered PII experiment
    var overrideAdpLogo = useAppSelector(selectIsUserEnteredPIIStep);
    var employerLogoAndConnector = useMemo(function () { return (React.createElement(React.Fragment, null,
        React.createElement(CompanyIcon, { result: loadedEmployer, dataTestId: "employerLogo", backgroundColor: companyColor }),
        React.createElement(Icon, { icon: "connector", className: "platformConnector", sx: { margin: '0 6px' } }))); }, [loadedEmployer, companyColor]);
    var linkApiTemplateType = getLinkApiTemplateType(linkApiResponse);
    var linkApiTemplateWithActions = getLinkApiTemplateWithActions(linkApiResponse);
    var hideLogos = useMemo(function () {
        return linkApiTemplateType
            ? shouldLinkApiTemplateHideLogos(linkApiTemplateWithActions, linkApiTemplateType)
            : false;
    }, [linkApiTemplateType, linkApiTemplateWithActions]);
    if (isOnTerminalScreen(currentPath))
        return null;
    if (!loadedPlatform)
        return null;
    if (hideLogos)
        return null;
    // TODO: CORE-1515 remove user-entered PII experiment
    var logoElement = overrideAdpLogo ? (React.createElement(CircularFrame, null,
        React.createElement(Icon, { icon: "pinwheelLogo", size: 30, color: {
                type: 'theme',
                colorLegacy: 'Primary/50',
                colorNext: 'brand/default',
            } }))) : (React.createElement(CompanyIcon, { result: loadedPlatform, logoUrlOverride: loadedPlatform.searchLogoUrl, dataTestId: "platformLogo" }));
    return (React.createElement(React.Fragment, null,
        shouldShowEmployerMapping({ loadedPlatform: loadedPlatform, loadedEmployer: loadedEmployer }) &&
            // Design-wise, it looks visually odd if we show a mapping of two generic icons, so instead we want to only
            // show a single generic icon in that case. Context: https://pinwheel.atlassian.net/browse/CON-459
            !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.useGenericProviderLogos)
            ? employerLogoAndConnector
            : null,
        logoElement));
};
export default LogoHeader;
